import { render, staticRenderFns } from "./ContainerOT.vue?vue&type=template&id=449b96a8&scoped=true"
import script from "./ContainerOT.vue?vue&type=script&lang=js"
export * from "./ContainerOT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b96a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449b96a8')) {
      api.createRecord('449b96a8', component.options)
    } else {
      api.reload('449b96a8', component.options)
    }
    module.hot.accept("./ContainerOT.vue?vue&type=template&id=449b96a8&scoped=true", function () {
      api.rerender('449b96a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ContainerOT.vue"
export default component.exports